import {
  ALL_CAMPAIGNS_DATA,
  FETCH_ALL_CAMPAIGN_TEMPLATES,
  FETCH_CAMPAIGNS_REQUEST,
  FETCH_CAMPAIGNS_SUCCESS,
  SET_CAMPAIGN_COUNT,
  UPDATE_CAMPAIGN_STATUS,
} from './campaignTypes';

const initialState = {
  campaigns: {},
  campaignCount: {},
  isLoading: true,
  allCampaigns: [],
  allCampaignTemplates: [],
};

const campaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CAMPAIGNS_REQUEST:
      return { ...state, isLoading: true };
    case FETCH_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        campaigns: { ...state.campaigns, [action.payload.key]: action.payload.campaigns },
        isLoading: false,
      };
    case SET_CAMPAIGN_COUNT:
      return {
        ...state,
        campaignCount: {
          ...state.campaignCount,
          [action.payload.key]: action.payload.count,
        },
      };
    case UPDATE_CAMPAIGN_STATUS: {
      const updatedCampaigns = {};
      Object.entries(state.campaigns).forEach(([key, eachPage]) => {
        const newPage = eachPage.map((campaign) => {
          if (campaign._id === action.payload.id) {
            return { ...campaign, status: action.payload.status === 'START' ? 'ACTIVE' : 'PAUSED' };
          } else {
            return campaign;
          }
        });

        updatedCampaigns[key] = newPage;
      });

      return { ...state, campaigns: updatedCampaigns };
    }
    case ALL_CAMPAIGNS_DATA:
      return {
        ...state,
        allCampaigns: action.payload,
      };

    case FETCH_ALL_CAMPAIGN_TEMPLATES:
      return {
        ...state,
        allCampaignTemplates: action.payload,
      };
    default:
      return { ...state };
  }
};

export default campaignReducer;
